export interface CalculatorSettings {
    flipTime: string;
    minProfitAmount: string;
    minProfitPercent: string;
    notary: string;
    brokerPercent: string;
    rentFees: string;
    maintenanceFees: string;
    portalFees: string;
    photographerAmount: string;
    saleBrokerPercent: string;
    pcc: string;
    tax?: string;
    renovationFrom1To30Amount: string;
    renovationFrom30To40Amount: string;
    renovationFrom40To50Amount: string;
    renovationFrom50To60Amount: string;
    renovationFrom60PlusAmount: string;
    userOption?: number;
    certainPrice?: number;

    renovation?: string;
    broker?: string;
    otherPurchaseCosts?: string;
    mediaFees?: string;
    otherOperatingCosts?: string;
    equipment?: string;
    homeStaging?: string;
    saleBroker?: string;
    otherSaleFees?: string;
    saleInterest?: string;
    otherCosts?: string;
}

export const initialCalculatorState: CalculatorSettings = {
    flipTime: '',
    minProfitAmount: '',
    minProfitPercent: '',
    notary: '',
    brokerPercent: '',
    rentFees: '',
    maintenanceFees: '',
    portalFees: '',
    photographerAmount: '',
    saleBrokerPercent: '',
    pcc: '',
    tax: '',
    renovationFrom1To30Amount: '',
    renovationFrom30To40Amount: '',
    renovationFrom40To50Amount: '',
    renovationFrom50To60Amount: '',
    renovationFrom60PlusAmount: '',
    userOption: 0,
    certainPrice: 0,

    renovation: '',
    broker: '',
    otherPurchaseCosts: '',
    mediaFees: '',
    otherOperatingCosts: '',
    equipment: '',
    homeStaging: '',
    saleBroker: '',
    otherSaleFees: '',
    saleInterest: '',
    otherCosts: ''
};

export enum CalculatorInputType {
  NUMBER = 'number',
  PERCENT = 'percent'
}
